"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeTypes = exports.SizeArray = exports.MSizeTypes = exports.AlertTypes = void 0;
var _type = require("../_utils/type");
var SizeArray = exports.SizeArray = ['s', 'default', 'l', 'auto'];
var SizeTypes = exports.SizeTypes = _type.tuple.apply(void 0, SizeArray);
var MSizeTypes = exports.MSizeTypes = (0, _type.tuple)('default', 'full');
var AlertTypes = exports.AlertTypes = (0, _type.tuple)('error', 'warning', 'success', 'pending', 'info');

/**
 * `Modal.confirm` 方法接收以下参数：
 */

/**
 *  `Modal.success`、`Modal.error` 及 `Modal.alert` 方法接收以下参数：
 */